// Component
import ImageShow from "views/components/ImageShow";

export default function NoData() {
    window.scrollTo({
        top: 0,
        left: 0
    });

    return <ImageShow className="imgError" src="/images/error/404.jpg" alt="สล็อตออนไลน์ 404" />;
}